export default "__VITE_ASSET__BI7t$nGx__"